import React from 'react';
import PropTypes from 'prop-types';
import { ControlLabel, Col, Row, Well } from 'react-bootstrap';
import FieldGroup from './FieldGroup';

const AssigneeInfo = ({ colSize, assignee, assigneeGroup }) => (
    <Col sm={colSize}>
        <Well>
            <Row>
                <Col componentClass={ControlLabel} sm={4} style={{ marginTop: 10 }}>
                    Assignee Group
                </Col>
                <Col sm={8} style={{ marginTop: 10 }}>
                    {assigneeGroup &&
                        assigneeGroup.length > 0 &&
                        assigneeGroup.map((as, i) => (
                            <p
                                key={as.name}
                                title={as.name}
                                className="text-ellipsis"
                                style={{ margin: 0 }}
                            >
                                {as.name}
                                {i < assigneeGroup.length - 1 ? ',' : ''}
                            </p>
                        ))}
                    {(!assigneeGroup || !assigneeGroup.length) && '-'}
                </Col>
            </Row>
            <FieldGroup label="Assignee" value={assignee} horizontal noBottomMargin readOnly />
        </Well>
    </Col>
);

AssigneeInfo.propTypes = {
    assigneeGroup: PropTypes.array,
    assignee: PropTypes.string,
};
AssigneeInfo.defaultProps = {};

export default AssigneeInfo;
